import React, { useEffect, useState } from "react";
import Select from "react-select/lib/Select";
import { DATE_TYPE_OPTIONS } from "./data";
import DatePicker from "react-datepicker";
import moment from "moment";
import DatePickerMulti from "react-multi-date-picker";

export default function DateComponent({ item, onDataChange, index, dKey }) {
  const [selectedDateType, setSelectedDateType] = useState("");
  const [selectedDate, setSelectedDate] = useState();
  const [dateRange, setDateRange] = useState([null, null]);

  useEffect(() => {
    if (item[dKey]) {
      if (Array.isArray(item[dKey])) {
        setDateRange(item[dKey]);
        setSelectedDate("");
        setSelectedDateType("DATE_RANGE");
      } else {
        setDateRange([null, null]);
        setSelectedDate(moment(item[dKey]).local());
        setSelectedDateType("DATE");
      }
    }
  }, [item]);

  const handleDateChange = value => {
    if (selectedDateType === "DATE") {
      setSelectedDate(moment(value).local());
      onDataChange(index, moment(value).format(), dKey);
    } else {
      const items = value.map(x => new Date(x));
      setDateRange(items);
      onDataChange(index, items, dKey);
    }
  };
  return (
    item && (
      <div style={{ flexGrow: 1 }} className="action-filter-row-item">
        <div style={{ flexGrow: 1 }}>
          <Select
            options={DATE_TYPE_OPTIONS}
            value={selectedDateType}
            onChange={e => setSelectedDateType(e.value)}
          />
        </div>
        {selectedDateType && (
          <div style={{ flexGrow: 1 }}>
            {selectedDateType === "DATE" ? (
              <DatePicker
                id="actionDueDate"
                placeholderText="Enter date: MM/DD/YYYY"
                className="form-control filter-action-date-input"
                selected={selectedDate}
                onChange={handleDateChange}
                showYearDropdown
              />
            ) : (
              <div className="action-filter-row-item">
                <DatePickerMulti
                  value={dateRange}
                  onChange={handleDateChange}
                  range
                  inputClass="custom-mdate-action-filterinput-filterpopover"
                />
              </div>
            )}
          </div>
        )}
      </div>
    )
  );
}
